
import Section from "./Section.vue";
export default {
  components: {
    Section,
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      tabsData: [
        {
          id: "15-18",
          title: "15-18 điểm",
          img: "2",
        },
        {
          id: "18-22",
          title: "18-22 điểm",
          img: "3",
        },
        {
          id: "22-25",
          title: "22-25 điểm",
          img: "4",
        },
        {
          id: "25-30",
          title: "25-30 điểm",
          img: "5",
        },
      ],
    };
  },
  methods: {
    getImageUrl(imgKey) {
      // Mapping giữa item.img và đường dẫn ảnh thực tế
      const imageMapping = {
        1: `${this.BASE_URL_STATIC}/storages/2025-08-14/b226a2ae594b4b7f968628dc925ec113.svg`,
        2: `${this.BASE_URL_STATIC}/storages/2025-08-14/0e7cc374de034e6383ffbc77cdad7d4a.svg`,
        3: `${this.BASE_URL_STATIC}/storages/2025-08-14/d134b00236fe4c37a949a3158fbb4748.svg`,
        4: `${this.BASE_URL_STATIC}/storages/2025-08-14/90b0639f51de42e58340d220a0f1eaa1.svg`,
        5: `${this.BASE_URL_STATIC}/storages/2025-08-14/69f6d5ac1f064f45ae86defe856244a8.svg`,
      };

      // Trả về ảnh tương ứng hoặc ảnh mặc định
      return (
        imageMapping[imgKey] ||
        `${this.BASE_URL_STATIC}/storages/2025-08-14/c7f835539ba24b13a5b0db62dc0c12ce.svg`
      );
    },
  },
};
